import React from 'react';
import SearchIcon from '@assets/icons/search-icon.svg';
import ResetFilterIcon from '@assets/icons/reset-filter-icon.svg';
import {
	SmartDivider, SmartTaskCount,
	SmartToolbarContainerFull,
	SmartToolbarGroupCenter,
	SmartToolbarGroupLeft, SmartToolbarGroupRight
} from '~/FielderElements/SmartTaskTable/SmartStyles';
import { Box, FormControl, IconButton, InputAdornment, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import { PersonAdd } from '@mui/icons-material';
import { MRT_ShowHideColumnsButton, MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton } from 'material-react-table';
import Button from '@mui/material/Button';

const SmartUserAuxToolbar = (
	{
		lan,
		totalNumberOfPartners,
		titlePartners,
		renderModal,
		showModalAddPartner,
		showModalDetailEditInvitation,
		showModalDetailEditPartner,
		isAllowedToPartnersAdd,
		addModal,
		changeTableView,
		showFilter,
		handleFilter,
		handleDeleteFilter,
		handlerEventKey,
		handleResetFilter,
		filter,
		optionSelected,
		POP_ADD,
		POP_ADD_INV,
		POP_EDIT,
		INVITATION_OPTION,
		I_AM_PARTNER_OPTION,
		MY_PARTNERS_OPTION,
		showCheckboxComponent,
		auxToolbarActions,
		table,
	}) => (
	<Box sx={SmartToolbarContainerFull}>
		<Box sx={SmartToolbarGroupLeft}>
			{renderModal(showModalAddPartner, 'addPartner', POP_ADD, false)}
			{renderModal(showModalDetailEditInvitation, 'pendentingInvitation', POP_ADD_INV, true)}
			{renderModal(showModalDetailEditPartner, 'partner', POP_EDIT, true)}
			{isAllowedToPartnersAdd && (
				<Tooltip arrow title={lan.addPartner || 'Add partner'}>
					<IconButton id='filter' onClick={addModal} size='snall' sx={{ color: '#dc5c87' }}>
						<PersonAdd />
					</IconButton>
				</Tooltip>
			)}
		</Box>
		<Box sx={SmartToolbarGroupCenter}>
			<FormControl size='small'>
				<Select
					id='select-partners-view'
					value={optionSelected}
					onChange={(e) => changeTableView(e.target.value)}
				>
					<MenuItem value={INVITATION_OPTION}> {lan.invitations} </MenuItem>
					<MenuItem value={I_AM_PARTNER_OPTION}> {lan.iAmPartner} </MenuItem>
					<MenuItem value={MY_PARTNERS_OPTION}> {lan.myPartners}</MenuItem>
				</Select>
			</FormControl>
			<MRT_ToggleFiltersButton table={table} />
			{showFilter && (
				<TextField
					id='tf-filter'
					size='small'
					value={filter || ''}
					onChange={(e) => handleDeleteFilter(e.target.value)}
					onKeyDown={handlerEventKey}
					slotProps={{
						input: {
							endAdornment: (
								<InputAdornment position='end'>
									{filter != null && (
										<IconButton size='small' onClick={handleResetFilter}>
											<img src={ResetFilterIcon} className='icon cursor-pointer' alt='' />
										</IconButton>
									)}
									<IconButton size='small' onClick={handleFilter}>
										<img src={SearchIcon} className='icon cursor-pointer' alt='' />
									</IconButton>
								</InputAdornment>
							)
						}
					}}
				/>
			)}
		</Box>
		<Box sx={SmartToolbarGroupRight}>
			{showCheckboxComponent && (auxToolbarActions)}
			<MRT_ShowHideColumnsButton table={table} />
			<MRT_ToggleFullScreenButton table={table} />
			<SmartDivider orientation="vertical" variant="middle" flexItem />
			<Button
				size="large"
				loading={false}
				disabled={false}
				style={{color: '#dc5c87'}}>
				<SmartTaskCount variant={'h5'}>{totalNumberOfPartners} {titlePartners}</SmartTaskCount>
			</Button>
		</Box>
	</Box>
);
export default SmartUserAuxToolbar;
